import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import SettingsIcon from '~components/Icons/Settings';

import { useDashboardVariantV2GiverContext } from '../../../../Context';

import { DashboardVariantV2GiverActionsWidgetActionButton } from '../styles';

const DashboardVariantV2GiverActionsWidgetSettingsAction = (): ReactElement => {
  const {
    dialogs: {
      configAndPreferences: {
        toggleOpen: toogleOpenDialogConfigAndPreferences,
      },
    },
  } = useDashboardVariantV2GiverContext();

  return (
    <DashboardVariantV2GiverActionsWidgetActionButton
      onClick={() => toogleOpenDialogConfigAndPreferences(true)}
    >
      <SettingsIcon color="disabled" sx={{ fontSize: 48 }} />

      <Typography variant="subtitle2" fontWeight="bold">
        PREFERENCIAS Y PERSONALIZACIÓN
      </Typography>
    </DashboardVariantV2GiverActionsWidgetActionButton>
  );
};

export default DashboardVariantV2GiverActionsWidgetSettingsAction;
